module.exports = __webpack_public_path__ + "img/for.6128875b.svg";